module.exports = __webpack_public_path__ + "static/media/cpp.ad5146ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/validations/images/cpp.png
// module id = 613
// module chunks = 147